var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          class: ["c-page-header__button--round", _vm.className],
          attrs: {
            "aria-expanded": _vm.showMenu,
            "aria-controls": "mobile-menu",
            id: "mobile-menu-button"
          },
          on: { click: _vm.openMenu }
        },
        [
          _c("v-icon", { attrs: { name: "icon-menu", size: "s" } }),
          _vm._v("\n\t\t‍"),
          _c("span", { staticClass: "t-visually-hidden" }, [
            _vm._v(_vm._s(_vm.menuButtonText))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "nav",
        {
          class: ["c-mobile-menu", { "c-mobile-menu--active": _vm.showMenu }],
          attrs: { id: "mobile-menu", "aria-label": "Mobilmeny" }
        },
        [
          _c("div", { staticClass: "c-mobile-menu__topbar" }, [
            _c(
              "button",
              {
                staticClass: "c-mobile-menu__close",
                attrs: { id: "mobile-menu-close" },
                on: { click: _vm.closeMenu }
              },
              [
                _c("v-icon", { attrs: { name: "icon-close", size: "xs" } }),
                _vm._v("\n\t\t\t\t‍"),
                _c("span", { staticClass: "t-visually-hidden" }, [
                  _vm._v(_vm._s(_vm.closeMenuButtonText))
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-mobile-menu__paneholder" }, [
            _c(
              "ul",
              { staticClass: "c-mobile-menu__list" },
              _vm._l(_vm.links, function(item, index) {
                return _c("v-mobile-menu-item", {
                  key: index,
                  attrs: {
                    id: index,
                    icon: item.icon,
                    name: item.name,
                    selected: item.selected,
                    items: item.pages
                  }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-mobile-menu__logo" }, [_c("v-logo")], 1)
        ]
      ),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade" } }, [
        _vm.showMenu
          ? _c("div", {
              staticClass:
                "c-page-header__overlay c-page-header__overlay--mobile-menu"
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }